import store from '@ivy/fts/ivyStore';
import axios from 'axios';
const { Vue, axios: axios2, Mint: Mint2 } = store.objects;
const disableLoadingConfig = {
    disableLoading: true,
};
// 获取转介绍价格
export async function getGoodsPrice(spuId) {
    return axios.get(`/api/activity/h5Activity/invitation/getGoodsPrice?spuId=${spuId}`);
}
// 获取spu数据
export async function getSpu(data = {}) {
    return axios.get('/api/goods/shop/search/goods/getSpu', {
        params: data,
    });
}
// 获取搭配售列表
export async function getCollectionList(data = {}) {
    return axios.get('/api/goods/shop/search/collocation/getCollocationListIter', {
        params: data,
        ...disableLoadingConfig,
    });
}
// 获取虚拟商品
export async function getSpuVirtual(data = {}) {
    return axios.get('/api/goods/shop/search/goods/getSpuVirtual', {
        params: {
            ...data,
        },
        ...disableLoadingConfig,
    });
}
// 获取优惠sku
export async function discountActivity(data = {}) {
    return axios.get('/api/goods/shop/search/goods/discountActivity', {
        params: data,
        ...disableLoadingConfig,
    });
}
// 添加购物车
export async function addToCart(data = {}) {
    return axios.post('/api/service-m/v1/shop/cart/addToCart', data);
}
// 编辑购物车
// 操作类型   1：加购，2：删除，3：选中，4：取消，5：全部选中，6：全部取消，7：替换SKU
export async function saveCart(data = {}) {
    return axios.post('/api/service-m/v1/shop/cart/saveCart', data);
}
// 购物车列表
export async function getCartData(data = {}) {
    return axios.get('/api/service-m/v1/shop/cart/getCartData', {
        params: data,
    });
}
// 购物车数量
export async function getCartCount(data = {}) {
    return axios.get('/api/service-m/v1/shop/cart/getCartCount', {
        params: data,
    });
}
// 确认订单
export async function getConfirmInfo(data = {}) {
    return axios.post('/api/service-m/v1/shop/order/orderConfirmInfo', data);
}
// 提交订单
export async function createOrder(data = {}) {
    return axios.post('/api/service-m/v1/shop/order/createOrder', data);
}
// 订单列表
export async function myOrders(data = {}) {
    return axios.get('/api/service-m/v1/shop/order/myOrders', {
        params: data,
    });
}
// 订单详情
export async function orderDetail(data = {}) {
    return axios.get('/api/service-m/v1/shop/order/orderDetail', {
        params: data,
    });
}
// 取消订单
export async function cancelOrder(data = {}) {
    return axios.post('/api/service-m/v1/shop/order/cancelOrder', data);
}
// 订单支付
export async function payOrder(data = {}) {
    return axios.post('/api/goods/v1/order/payOrder', data);
}
